<template>
	<footer id="footer" data-qa="footer-layout">

		<div id="footer__map" v-if="!login.logged" style="display: none;">

			<div id="footer__map--content">

				<!-- COLUNA 1: LINKS DIRETOS -->
				<div class="footer__group footer__group--direct">
					<div class="content">
						<a href="#" class="footer__direct">Cooking</a>
						<a href="#" class="footer__direct">Casa Conectada</a>
						<a href="#" class="footer__direct">Life Style</a>
						<a href="#" class="footer__direct">Entretenimento</a>
						<a href="#" class="footer__direct">Notícias e Dicas</a>
						<a href="#" class="footer__direct">Novidades</a>
					</div>
				</div>

				<!-- COLUNAS 2 + 3 COMBINADAS: LOVERSLG -->
				<details class="footer__group footer__group--split">
					<summary>LoversLG</summary>
					<div class="footer__split content">
						<ul class="footer__list">
							<li><a href="#" class="footer__link">TVs</a></li>
							<li><a href="#" class="footer__link">Áudio LG</a></li>
							<li><a href="#" class="footer__link">Fones</a></li>
							<li><a href="#" class="footer__link">Monitores</a></li>
							<li><a href="#" class="footer__link">Lousa Digital</a></li>
						<!-- </ul>
						<ul> -->
							<li><a href="#" class="footer__link">Ar-Condicionado</a></li>
							<li><a href="#" class="footer__link">Purificador de Ar</a></li>
							<li><a href="#" class="footer__link">Geladeiras</a></li>
							<li><a href="#" class="footer__link">Lava e Seca</a></li>
							<li><a href="#" class="footer__link">Micro-ondas</a></li>
						</ul>
					</div>
				</details>



				<!-- COLUNA 4: PROMOÇÕES -->
				<details class="footer__group">
					<summary>Promoções</summary>
					<div class="content">
						<ul>
							<li><a href="#" class="footer__link">Eventos</a></li>
							<li><a href="#" class="footer__link">Promoções</a></li>
							<li><a href="#" class="footer__link">Ofertas Especiais</a></li>
							<li><a href="#" class="footer__link">LG Pergunta</a></li>
							<li><a href="#" class="footer__link">LG da Sorte</a></li>
						</ul>
					</div>
				</details>

				<!-- COLUNA 5: SUPORTE -->
				<details class="footer__group">
					<summary>Suporte</summary>
					<div class="content">
						<ul>
							<li><a href="#" class="footer__link">Relatar Problemas</a></li>
							<li><a href="#" class="footer__link">Solicitar Suporte Técnico</a></li>
							<li><a href="#" class="footer__link">Enviar Sugestões</a></li>
							<li><a href="#" class="footer__link">Contato Direto</a></li>
						</ul>
					</div>
				</details>

				<!-- COLUNA 6: LINKS DIRETOS -->
				<div class="footer__group footer__group--direct">
					<div class="content">
						<a href="#" class="footer__direct">Meu Perfil</a>
						<a href="#" class="footer__direct">LG Rewards</a>
						<a href="#" class="footer__direct external" target="_blank">LG Family Club House</a>
					</div>
				</div>

			</div>

		</div>



		<section id="footer__bottom">

			<div id="footer__bottom--content">

				<div class="row__1">

				<!-- <router-link to="" class="link__country">Acessibilidade</router-link>
				<router-link to="" class="link__country">Termos & Condições</router-link>
				<router-link to="" class="link__country">Privacidade</router-link>
				<router-link to="" class="link__country">FAQ & Suporte</router-link>
				<router-link to="" class="link__country">Loja Online LG</router-link> -->

 				<!-- <router-link :to="$t('footer.termsOfUse.url')" class="link__country" :aria-label="$t('footer.termsOfUse.label')">{{ $t('footer.termsOfUse.label') }}</router-link>
				<router-link :to="$t('footer.personalData.url')" class="link__country"  v-if="aux === '/ec/'" :aria-label="$t('footer.personalData.label')">{{ $t('footer.personalData.label') }}</router-link>
				<router-link :to="$t('footer.privacyPolicy.url')" class="link__country" :aria-label="$t('footer.privacyPolicy.label')">{{ $t('footer.privacyPolicy.label') }}</router-link>
				<router-link :to="$t('footer.privacyCookies.url')" class="link__country" :aria-label="$t('footer.privacyCookies.label')">{{ $t('footer.privacyCookies.label') }}</router-link>  -->


				<!-- LINK NEW PAGE -->
				<router-link :to="$t('footer.termsOfUse.url')" class="link__country" data-qa="footer-terms-link" :aria-label="$t('footer.termsOfUse.label')">{{ $t('footer.termsOfUse.label') }}</router-link>
				<router-link :to="$t('footer.personalData.url')" class="link__country" data-qa="footer-personal-data-link" v-if="aux === '/ec/'" :aria-label="$t('footer.personalData.label')">{{ $t('footer.personalData.label') }}</router-link>
				<router-link :to="$t('footer.privacyPolicy.url')" class="link__country" data-qa="footer-privacy-policy-link" :aria-label="$t('footer.privacyPolicy.label')">{{ $t('footer.privacyPolicy.label') }}</router-link>
				<router-link :to="$t('footer.privacyCookies.url')" class="link__country" data-qa="footer-privacy-cookies-link" :aria-label="$t('footer.privacyCookies.label')">{{ $t('footer.privacyCookies.label') }}</router-link>
				
				<!-- <router-link :to="$t('footer.lgpd.url')" class="link__country">{{ $t('footer.lgpd.label') }}</router-link> -->
				<a :href="$t('footer.lgpd.url')" class="link__country" data-qa="footer-lgpd-link" v-if="aux === '/br/'" :aria-label="$t('footer.lgpd.label')">{{ $t('footer.lgpd.label') }}</a>

				<router-link :to="$t('footer.legal.url')" class="link__country" data-qa="footer-legal-link" :aria-label="$t('footer.legal.label')">{{ $t('footer.legal.label') }}</router-link>
				<router-link :to="$t('footer.accessibility.url')" class="link__country" data-qa="footer-accessibility-link" :aria-label="$t('footer.accessibility.label')">{{ $t('footer.accessibility.label') }}</router-link>

				</div>

				<div class="row__2">
					<div class="logo">
						<LogoLg lgCircle="var(--lg-red)" lgStroke="var(--white)" lgType="var(--white)"
							:aria-label="$t('a11y.lgFooterLogo')" />
					</div>

					<div class="social__links">
						<a
							v-for="media in validSocialMedias"
							:key="media.id || `${media.socialMediaTypeId}-${getSocialUrl(media)}`"
							:href="getSocialUrl(media)"
							target="_blank"
							rel="noopener noreferrer"
							:class="getClass(media.socialMediaTypeId)"
							:title="getTitle(media.socialMediaTypeId)"
							:aria-label="getTitle(media.socialMediaTypeId)"
							data-qa="footer-social-link"
							:data-qa-id="media.id || media.socialMediaTypeId || media.key"
						>
							<Icons :name="getIconName(media.socialMediaTypeId)" />
						</a>
					</div>

				</div>

				<div class="row__3">
					<p>Copyright © 2009-{{ currentYear }} {{ $t('footer.reserved') }}</p>
				</div>
			</div>
		</section>
		
	</footer>
</template>

<script>
import LogoLg from '@/components/template/LogoLg.vue'
import Icons from '@/components/Icons.vue'
import { RouterLink } from 'vue-router';
export default {
	name: 'Footer',
	components: {
		LogoLg,
		Icons
	},
	props: {
		socialMedias: {
			type: Array,
			default: () => []
		},
		country: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			currentYear: new Date().getFullYear(),
			aux: import.meta.env.VITE_BASE_PATH
		};
	},
	computed: {
		linhasAddress() {
			if (!this.country?.address)
				return []
			var linhasAux = this.country.address.split('\n')

			if (!linhasAux || linhasAux.length <= 0)
				linhasAux = [this.country.address]

			return linhasAux
		},
		login() {
			return {
				name: this.$store.state.auth.user?.name,
				logged: !!this.$store.state.auth.user
			}
		},
		validSocialMedias() {
			const fromApi = this.socialMedias.filter(media => media?.isActive !== false && this.getSocialUrl(media))
			if (fromApi.length) return fromApi
			return this.configuredSocialMedias
		},
		configuredSocialMedias() {
			const networks = [
				{ key: 'tiktok', socialMediaTypeId: 1 },
				{ key: 'facebook', socialMediaTypeId: 2 },
				{ key: 'instagram', socialMediaTypeId: 3 },
				{ key: 'youtube', socialMediaTypeId: 4 },
				{ key: 'twitter', socialMediaTypeId: 5 }
			]

			return networks
				.map(network => ({
					...network,
					id: `configured-${network.key}`,
					url: this.changeArroba(this.$t(`footer.social.${network.key}`)).trim()
				}))
				.filter(media => media.url)
		}
	},
	methods: {
		changeLanguage(event) {
			this.$i18n.locale = event.target.value;
		},
		changeArroba(url) {
			return url.replace('%ARR%', '@')
		},
		getSocialUrl(media) {
			return media?.url || media?.link || ''
		},
		getIconName(typeId) {
			switch (typeId) {
				case 1: return 'tiktok';
				case 2: return 'facebook';
				case 3: return 'instagram';
				case 4: return 'youtube';
				case 5: return 'ex';
				default: return 'ex';
			}
		},
		getTitle(typeId) {
			switch (typeId) {
				case 1: return 'tiktok';
				case 2: return 'Facebook';
				case 3: return 'Instagram';
				case 4: return 'YouTube';
				case 5: return 'Ex';
				default: return 'Ex';
			}
		},
		getClass(typeId) {
			switch (typeId) {
				case 1: return 'tiktok';
				case 2: return 'facebook';
				case 3: return 'instagram';
				case 4: return 'youtube';
				case 5: return '';
				default: return '';
			}
		}
	},
	mounted() {
		// controla o comportamento do footer para exibir os detalhes abertos por padrão em telas maiores
		if (window.innerWidth >= 768) {
			const groups = document.querySelectorAll('.footer__group');
			groups.forEach((el) => {
				el.setAttribute('open', true);
			});
		}
	}

}
</script>


<style lang="sass" scoped>
@use '../../assets/sass/utilities/_colors' as *
@use '../../assets/sass/utilities/_responsive' as *
@use '../../assets/sass/utilities/_mixin' as *

#footer

	width: 100%
	

	#footer__bottom
		padding-block: 80px
		background-color: var(--dark-custom)

		&--content
			margin-inline: auto
			width: min(100%, var(--contentSize))
			padding-inline: var(--padding-mobile)
			+respond-to($breakpoint-sm-min)
				padding-inline: 0

			@container body (width <= 1440px)
				transition: var(--transition)
				+respond-to($breakpoint-sm-min)
					padding-inline: 2rem
			
			.row__1
				display: flex
				gap: 0.75rem
				margin-bottom: 1.75rem
				flex-direction: column

				+respond-to($breakpoint-sm-min)
					flex-direction: row
					gap: 2.375rem

				.link__country
					color: var(--light)
					font-size: 1rem
					text-decoration: none

			.row__2
				display: flex
				justify-content: space-between
				

				.logo
					width: 90px

				.social__links
					display: flex
					justify-content: flex-end
					align-items: center
					gap: 10px

					a
						display: flex
						justify-content: center
						align-items: center
						width: 32px
						height: 32px
						border-radius: 50%
						padding: 9px
						background-color: var(--white)
						color: var(--black)	
						transition: all 0.23s ease

						&.facebook
							&:hover
								color: #0765FF

						&.youtube
							&:hover
								color: #ff0000
						
						&.instagram
							&:hover
								color: #F20084
						
						&.ex
							&:hover
								color: var(--lg-dark-gray-100)
			.row__3
				margin-top: 10px
				p
					color: var(--light)
					font-size: 1rem
		

%bg-arrow
	position: absolute
	right: 0
	top: 0
	width: 19px
	height: 30px
	background-image: url("data:image/svg+xml,%3Csvg width='20' height='35' viewBox='0 0 20 35' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='3.0293' y='0.916992' width='24' height='4' rx='2' transform='rotate(45 3.0293 0.916992)' fill='%231B1C1E'/%3E%3Crect x='0.0292969' y='31.8877' width='24' height='4' rx='2' transform='rotate(-45 0.0292969 31.8877)' fill='%231B1C1E'/%3E%3C/svg%3E")
	background-repeat: no-repeat
	background-size: contain
	content: ""
	transition: transform 0.3s ease
	transform: rotate(0deg)

#footer__map
	--gap: 29px
	padding-block: 80px
	background-color: var(--lg-light-gray-300)
	border-top: 1px solid var(--lg-mid-gray-200)
	+respond-to($breakpoint-sm-min)
		border-top: none
		

	&--content
		margin-inline: auto
		width: min(100%, var(--contentSize))
		padding-inline: var(--padding-mobile)
		display: flex
		flex-wrap: wrap
		gap: var(--gap)
		+respond-to($breakpoint-sm-min)
			gap: 2rem
			padding-inline: 0	

		@container body (width <= 1440px)
			transition: var(--transition)
			+respond-to($breakpoint-sm-min)
				padding-inline: 2rem

	
		.footer__group 
			flex: 1 1 0
			border: none

			.content
				width: 100%
				display: flex
				gap: var(--gap)
				height: 100%

				flex-direction: column
				+respond-to($breakpoint-sm-min)
					gap: 8px
					

				&:has(ul + ul)
					gap: 0
					display: flex
					flex-direction: column					
					+respond-to($breakpoint-sm-min)
						flex-direction: row
						justify-content: space-between
						gap: 1rem
						

				ul
					display: flex
					flex-direction: column
					gap: 8px
					margin-top: 30px
					+respond-to($breakpoint-sm-min)
						margin-top: 0


				.footer__direct
					color: var(--dark-custom)
					@include font-size (24px, 24px)
					text-decoration: none
					display: block
					position: relative
					font-weight: 400
					+respond-to($breakpoint-sm-min)
						font-weight: 700

					&:hover
						text-decoration: underline
						

					&::after
						@extend %bg-arrow
						+respond-to($breakpoint-sm-min)
							display: none

					&.external						
						&::after
							position: absolute
							right: 0
							
							
							background-repeat: no-repeat
							background-size: contain
							content: ""
							width: 19px
							height: 30px
							
							background-image: url("data:image/svg+xml,%3Csvg width='20' height='35' viewBox='0 0 20 35' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='3.0293' y='0.916992' width='24' height='4' rx='2' transform='rotate(45 3.0293 0.916992)' fill='%231B1C1E'/%3E%3Crect x='0.0292969' y='31.8877' width='24' height='4' rx='2' transform='rotate(-45 0.0292969 31.8877)' fill='%231B1C1E'/%3E%3C/svg%3E")
							+respond-to($breakpoint-sm-min)
								background-image: url("data:image/svg+xml,%3Csvg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2333_2259)'%3E%3Cg clip-path='url(%23clip1_2333_2259)'%3E%3Cpath d='M0.7 12.3281L0 11.6281L10.3 1.32812H1.9V0.328125H11.5H12V0.828125V10.4281H11V2.02813L0.7 12.3281Z' fill='%231B1C1E'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2333_2259'%3E%3Crect width='12' height='12' fill='white' transform='translate(0 0.328125)'/%3E%3C/clipPath%3E%3CclipPath id='clip1_2333_2259'%3E%3Crect width='12' height='12' fill='white' transform='translate(0 0.328125)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
								width: 12px
								height: 12px
								top: 10px
								display: block

				.footer__link

					color: var(--dark-custom)
					font-size: 1rem
					text-decoration: none
					white-space: nowrap
					
					&:hover
						text-decoration: underline
			
				
	
			summary 
				list-style: none
				cursor: pointer
				position: relative
				color: var(--dark-custom)
				@include font-size (24px, 24px)
				text-decoration: none
				font-weight: 400
				+respond-to($breakpoint-sm-min)
					margin-bottom: 1.5rem
					font-weight: 700

			
				&::after
					@extend %bg-arrow

			&[open] summary::after
				transform: rotate(90deg)

		// ESTILO PARA .footer__split (duas colunas dentro de um grupo)

		@media (max-width: 768px)
			flex-direction: column

			.footer__split
				flex-direction: column

			.footer__group:not([open]) ul,
			.footer__group:not([open]) .footer__split
				display: none


			// DESKTOP
		+respond-to($breakpoint-sm-min)
			flex-direction: row


			.footer__group
				summary
					pointer-events: none
					cursor: default

					&::after
						display: none

</style>
